import React, { useState, useEffect } from "react";
import BeatLoader from "react-spinners/BeatLoader";
import Chip from '@material-ui/core/Chip';
import swal from 'sweetalert'
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styles from "assets/jss/material-kit-react/views/learningPage.js";
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from "@material-ui/core/styles";
import ReactHtmlParser from 'react-html-parser';


const useStyles = makeStyles(styles);

export default function Calander(props) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(true);

  const [text, setText] = React.useState("");
 
  useEffect(()=>{
    const script = document.createElement("script");
    script.src = "/Classes/Calander/func.js";
    script.async = true;
    document.body.appendChild(script);
  },[])
  fetch("/Classes/Calander/index.html")
    .then((response) => response.text())
    .then((textContent) => {
      setText(textContent);
      setLoading(false)
    });

  return (
    <div className={classes.container}>
      <div className={classes.center + " " + classes.fastAccess}>
        <BeatLoader loading={loading} color={"gray"} size={15} />
      </div>

      <GridContainer justify="left" className={classes.box}>
        <GridItem className={classes.rightAlign} xs={12} sm={12} md={12}>
      <link rel="stylesheet" href="/Classes/Calander/styles.css" />
        {ReactHtmlParser(text)}
        </GridItem>

      </GridContainer>
      <div className={classes.description}>
        <p>
          {" "}
        </p>
      </div>
      <GridContainer justify="center">
      </GridContainer>
    </div>
  );
}





